import React, { useEffect, useState } from 'react'
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Tooltip } from '@mui/material'
import { Clear as ClearIcon } from '@mui/icons-material'
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/styles'
import Icon from '@mui/material/Icon'
import AddIcon from '@mui/icons-material/Add'
import columns from './table_def'
import { fetchUsersData } from '../../actions'
import { useHistory } from 'react-router-dom'
import { DataGrid } from '@mui/x-data-grid'
import { RootState } from '../../reducers'
import { useDispatch, useSelector } from 'react-redux'
import { Box } from '@mui/material'
import { userListgrid } from './../../interfaces/user'
import { EditUserAccount } from './EditUserAccount'
import DeactivateUserAccount from './DeactivateUserAccount'
import ActivateUserAccount from './ActivateUserAccount'
import UserView from './UserView'
import { useStyles } from './UserProfileStyles'

export function Users(): JSX.Element {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('lg'))
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const [editUserOpen, setEditUserOpen] = useState(false)
  const [deactivateUserOpen, setDeactivateUserOpen] = useState(false)
  const [activateUserOpen, setActivateUserOpen] = useState(false)
  const [userViewOpen, setUserViewOpen] = useState(false)
  // eslint-disable-next-line @typescript-eslint/ban-types
  const [userData, setUserData] = useState<{} | null>()
  const [userId, SetUserId] = useState(null)
  const [lastIndex, setLastIndex] = useState<number>()
  const [selectedUserData, setSelectedUserData] = useState()

  const getUsers = useSelector((state: RootState) => state.getUsers)
  // const displayUsersList = getUsers.data11.data123
  const displayUsersList = getUsers?.data
  const { role } = useSelector((state: RootState) => state.userLogin)
  if (role === 'NL_WOMA_ADMIN') {
    const iconRender: userListgrid = {
      field: '',
      headerName: 'Actions',
      disableColumnMenu: true,
      width: 168,
      disableClickEventBubbling: true,
      headerClassName: 'super-app-theme--header',
      filterable: false,
      renderCell: (params) => {
        return (
          <div>
            <Tooltip title="User profile" placement="top-start">
              <Icon onClick={(event) => onProfileView(event, params.row)}>info_outlined</Icon>
            </Tooltip>
            &nbsp;&nbsp;&nbsp;
            <Tooltip title="Edit User" placement="top-start">
              <Icon onClick={(event) => onEditUser(event, params.row)}>edit</Icon>
            </Tooltip>
            &nbsp;&nbsp;&nbsp;
            {params.row.user_status === true && (
              <Tooltip title="Deactivate User" placement="top-start">
                <AssignmentIndOutlinedIcon
                  style={{ color: 'rgb(10, 104, 141)' }}
                  onClick={(event) => handleDeactivateUserOpen(event, params.row)}
                >
                  Deactivate User Account
                </AssignmentIndOutlinedIcon>
              </Tooltip>
            )}
            {params.row.user_status === false && (
              <Tooltip title="Activate User" placement="top-start">
                <AssignmentIndOutlinedIcon
                  color="disabled"
                  onClick={(event) => handleActivateUserOpen(event, params.row)}
                >
                  Activate User Account
                </AssignmentIndOutlinedIcon>
              </Tooltip>
            )}
          </div>
        )
      },
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    columns.push(iconRender)
  } else if (role === 'NL_LabManager' || role === 'NL_SpecimenLogistics') {
    const iconRender: userListgrid = {
      field: '',
      headerName: 'Actions',
      disableColumnMenu: true,
      width: 168,
      disableClickEventBubbling: true,
      headerClassName: 'super-app-theme--header',
      filterable: false,
      renderCell: (params) => {
        return (
          <div>
            <Tooltip title="User profile" placement="top-start">
              <Icon onClick={(event) => onProfileView(event, params.row)}>info_outlined</Icon>
            </Tooltip>
            &nbsp;&nbsp;&nbsp;
            <Tooltip title="Edit User" placement="top-start">
              <Icon onClick={(event) => onEditUser(event, params.row)}>edit</Icon>
            </Tooltip>
          </div>
        )
      },
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    columns.push(iconRender)
  }

  const handleDeactivateUserOpen = (event, row: any) => {
    setUserData(row)
    setDeactivateUserOpen(true)
  }

  const handleActivateUserOpen = (event, row: any) => {
    setUserData(row)
    setActivateUserOpen(true)
  }

  useEffect(() => {
    dispatch(fetchUsersData())
  }, [dispatch])

  const onAddUser = (e) => {
    e.stopPropagation()
    history.push('manager-options/add-user-account')
  }

  const onEditUser = (e, rowData) => {
    setUserData(rowData)
    const id = rowData.userId
    SetUserId(id)
    setEditUserOpen(true)
  }

  const onProfileView = (e, rowData) => {
    setUserViewOpen(true)
    setSelectedUserData(rowData)
  }

  const handleDeactivateUserClose = () => setDeactivateUserOpen(false)

  const handleActivateUserClose = () => setActivateUserOpen(false)

  const handleClose = (e) => {
    e.stopPropagation()
    setUserViewOpen(false)
    setEditUserOpen(false)
    setDeactivateUserOpen(false)
    setActivateUserOpen(false)
  }

  useEffect(() => {
    if (getUsers?.data) {
      const max = getUsers?.data.reduce((prev, current) => (prev.userId > current.userId ? prev : current))
      const index = parseInt(max.userId) + 1
      setLastIndex(index)
    }
  }, [displayUsersList, getUsers?.data])
  return (
    <div>
      <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'left', mt: '10px' }}>
        <p style={{ color: '#0a688d', fontWeight: 500 }}>Users configured for Premeris diagnosis</p>
      </Box>
      <Dialog
        open={userViewOpen}
        onClose={handleClose}
        fullScreen={fullScreen}
        maxWidth={'md'}
        fullWidth
        scroll={'paper'}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title" className={classes.dialogTitle}>
          User Profile
        </DialogTitle>
        <DialogContent dividers={true}>
          <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
            <UserView user={selectedUserData} />
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.buttonActions}>
          <Button variant="outlined" onClick={handleClose} endIcon={<ClearIcon />}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {editUserOpen && (
        <EditUserAccount
          user={userData}
          handleClose={handleClose}
          editUserOpen={editUserOpen}
          setEditUserOpen={setEditUserOpen}
        />
      )}

      {deactivateUserOpen && (
        <DeactivateUserAccount
          userId={displayUsersList[0].user_id}
          open={deactivateUserOpen}
          onClose={handleDeactivateUserClose}
          userDetails={userData}
        />
      )}

      {activateUserOpen && (
        <ActivateUserAccount
          userId={displayUsersList[0].user_id}
          open={activateUserOpen}
          onClose={handleActivateUserClose}
          userDetails={userData}
        />
      )}

      <Box style={{ marginTop: '0px' }}>
        {role !== 'NL_LabManager' && role !== 'NL_SpecimenLogistics' && (
          <div style={{ float: 'right', marginTop: '-45px' }}>
            <Button variant="outlined" startIcon={<AddIcon />} className={classes.btn} onClick={onAddUser}>
              Enable New Account
            </Button>
          </div>
        )}
        {displayUsersList && displayUsersList.length > 0 && (
          <Box
            sx={{
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#0d688d73',
                fontWeight: '600',
              },
              '& .MuiDataGrid-columnHeader--moving': {
                backgroundColor: 'transparent !important',
              },
            }}
          >
            <DataGrid
              disableColumnSelector
              autoHeight
              rows={displayUsersList}
              columns={columns}
              loading={getUsers?.fetchInProgress}
              pagination
              pageSize={10}
              rowsPerPageOptions={[10]}
              disableSelectionOnClick={true}
            />
          </Box>
        )}
      </Box>
    </div>
  )
}
